module.exports = __webpack_public_path__ + "assets/img/smartTV2-icon2.9d2d97fb.svg";